@if (!loading) {
  <div class="deploy-device-container">
    <div class="topbar">
      <div class="topbar-side topbar-left">
        @if (data.enablePlatformFamilySwitcher) {
          <div class="platform-family-switch" role="tablist" aria-label="Device family">
            <button type="button" class="family-option" [ngClass]="{'active': activePlatformFamily === 'desktop'}" [attr.aria-selected]="activePlatformFamily === 'desktop'" (click)="switchPlatformFamily('desktop')" data-testing-id="deploy-device-dialog-platform-family-desktop-btn">Desktop</button>
            <button type="button" class="family-option" [ngClass]="{'active': activePlatformFamily === 'mobile'}" [attr.aria-selected]="activePlatformFamily === 'mobile'" (click)="switchPlatformFamily('mobile')" data-testing-id="deploy-device-dialog-platform-family-mobile-btn">Mobile</button>
          </div>
        }
      </div>

      <div class="topbar-center">
        <input pInputText placeholder="Filter Devices" [(ngModel)]="filterTerm" (input)="searchUpdated()" data-testing-id="deploy-device-dialog-filter-input">
      </div>

      <div class="topbar-side topbar-right">
        @if (canSwitchGroupingVariant) {
        <div class="hierarchy-type-switch">
          <div class="label" pTooltip="Select the operating system first" tooltipPosition="bottom">OS</div>
          <p-toggle-switch [ngModel]="selectedGroupingVariant === 'browser'" (onChange)="changeGroupingVariant($event)" data-testing-id="deploy-device-dialog-grouping-variant-switch"></p-toggle-switch>
          <div class="label" pTooltip="Select the browser first" tooltipPosition="bottom">Browser</div>
        </div>
        }
      </div>
    </div>
    <div class="filterbar">
      @if (hasFavorites) {
        <div class="filter-entry">
          <p-checkbox #favorites [binary]="true" [(ngModel)]="favoritesOnly" (onChange)="filterChanged()" data-testing-id="deploy-device-dialog-favorites-checkbox"></p-checkbox>
          <label for="favorites">Favorites</label>
        </div>
      }
      @if (activePlatformFamily === 'mobile') {
        <div class="filter-entry">
          <p-checkbox #fullversion [binary]="true" [(ngModel)]="fullVersion" (onChange)="filterChanged()" data-testing-id="deploy-device-dialog-full-version-checkbox"></p-checkbox>
          <label for="fullversion">Full OS version</label>
        </div>
        <div class="filter-entry">
          <p-checkbox #cuttingedge [binary]="true" [(ngModel)]="cuttingEdge" (onChange)="filterChanged()" data-testing-id="deploy-device-dialog-cutting-edge-checkbox"></p-checkbox>
          <label for="cuttingedge">Cutting-edge Versions</label>
        </div>
        @if (showAudioFilter) {
          <div class="filter-entry">
            <p-checkbox #audio [binary]="true" [(ngModel)]="audioOnly" (onChange)="filterChanged()" data-testing-id="deploy-device-dialog-audio-checkbox"></p-checkbox>
            <label for="audio">Audio Streaming</label>
          </div>
        }
        @if (showIosControlsFilter) {
          <div class="filter-entry">
            <p-checkbox #ioscontrols [binary]="true" [(ngModel)]="iosControls" (onChange)="filterChanged()" data-testing-id="deploy-device-dialog-ios-controls-checkbox"></p-checkbox>
            <label for="ioscontrols">Advanced iOS Controls</label>
          </div>
        }
      }
    </div>
    @if (filteredDeployables.length === 0) {
      <div class="empty-message">
        No deployable is available or matches your filter.
      </div>
    } @else {
      <div class="deployable-columns">
        @for (column of deployableColums; track i; let i = $index) {
          <!--          Hide columns that are collapsable and only have one entry-->
                  <!--          TODO: find a better solution to do this only for iOS-->
          @if (column.displayType === 'column' && !(column?.collapsable && column.entries.length === 1 && column.entries[0].group[0].deployables[0].platform.platformType === 'iOS')) {
            <div class="deployable-column">
              @for (entry of column.entries; track j; let j = $index) {
                <div class="column-entry" (click)="selectDeployable(entry, i)" [ngClass]="{'highlighted': selectedEntries[i] === entry.id}" [attr.data-testing-id]="getColumnEntryTestingId(entry, i)">
                  @switch (entry.representation.type) {
                    @case ('label') {
                      @if (entry.representation?.groupImage) {
                        <img [src]="entry.representation.groupImage | async">
                      }
                      <span>{{ entry.representation.groupLabel }}</span>
                    }
                    @case ('browsers') {
                      <wm-browsers-info [browsers]="entry.representation.browsers"></wm-browsers-info>
                    }
                  }
                  @if (isDeployedEntry(entry)) {
                    <fa-icon class="deployed-icon" [icon]="faTv" pTooltip="A suitable device is already deployed"></fa-icon>
                  }
                </div>
              }
            </div>
          } @else if (column.displayType === 'grid') {
            <span>Foo</span>
          }
        }
      </div>
      <div class="deployable-details">
        <div class="general-details">
          <div class="logo">
            @if (selectedDeployableDisplayData?.logo) {
              <img [src]="selectedDeployableDisplayData.logo">
            }
          </div>
          <div>
            @if (activePlatformFamily === 'desktop') {
              {{ displayPlatformName }}
            } @else if (activePlatformFamily === 'mobile') {
              {{ displayModelName }}
            }
            <fa-icon
                    [icon]="faStar"
                    class="falcon-star"
                    [class.is-favorite]="isFavorite(selectedDeployable)"
                    (click)="toggleFavorite(selectedDeployable)"
                    data-testing-id="deploy-device-dialog-favorite-toggle">
            </fa-icon>
          </div>
          <div class="slot-name">
            {{slotNameForSelected | async}}
          </div>
        </div>
        <div class="specific-details">
          @if (activePlatformFamily === 'desktop') {
            <div class="detail-entry">Locale: {{ selectedDeployable.properties[DevicePropertyNames.Locale] }}</div>
          } @else if (activePlatformFamily === 'mobile') {
            @if (displayManufacturerName) {
              <div class="detail-entry">
                {{ displayManufacturerName }}
              </div>
            }
            @if (displayPlatformName) {
              <div class="detail-entry">
                {{ displayPlatformName }}
              </div>
            }
          }
          <div>
            <wm-browsers-info [browsers]="selectedDeployableBrowsers" [multiline]="true"></wm-browsers-info>
          </div>
        </div>
        <div class="settings">
          <div>
            <input type="text" placeholder="Device Name" [(ngModel)]="customDeviceName" [disabled]="isSelectedDeployableAlreadyDeployed" (keydown.enter)="!requestInProgress && requestDeploymentOfTemplate()" pInputText data-testing-id="deploy-device-dialog-device-name-input"/>
          </div>
          @if (selectedSupportsResolution) {
            <div>
              <p-select appendTo="body" baseZIndex="10000" [options]="availableResolutions" [(ngModel)]="desiredResolution" class="wm-deployable-group-subselection-control" data-testing-id="deploy-device-dialog-resolution-select"></p-select>
            </div>
          }
          @if (data.showAllowAutomation) {
            <div class="automation">
              <p-checkbox #automation [binary]="true" [(ngModel)]="allowAutomation" data-testing-id="deploy-device-dialog-allow-automation-checkbox"></p-checkbox>
              <label [for]="automation">
                Allow automation
              </label>
            </div>
          }
          @if (data.showStartTestOnDeploy) {
            <div class="automation">
              <p-checkbox #startTestOnDeploy [binary]="true" [(ngModel)]="shouldStartTestOnDeploy" data-testing-id="deploy-device-dialog-start-test-on-deploy-checkbox"></p-checkbox>
              <label [for]="startTestOnDeploy">
                Start manual test in workbench
              </label>
            </div>
          }
          @if (activePlatformFamily === 'desktop' && selectedGroupingVariant === 'browser' && allowStartBrowserSession) {
            <div class="session">
              <p-checkbox #session [binary]="true" [(ngModel)]="browserSession" data-testing-id="deploy-device-dialog-browser-session-checkbox"></p-checkbox>
              <label [for]="session">
                Start Browser Session
              </label>
            </div>
          }
        </div>
        <div class="deploy-button">
          @if (data.showDeployAndOpen) {
            <p-split-button class="deploy-split-button"
              (onClick)="requestDeploymentOfTemplate()"
              [disabled]="requestInProgress"
              [loading]="requestInProgress"
              [label]="getDeployButtonText()"
              appendTo="body"
              menuStyleClass="deploy-split-button-menu"
              [model]="deployButtonModel"
              data-testing-id="deploy-device-dialog-deploy-btn"></p-split-button>
          } @else {
            <button class="button" [disabled]="requestInProgress" (click)="requestDeploymentOfTemplate()" pButton data-testing-id="deploy-device-dialog-deploy-btn">
              {{getDeployButtonText()}}
              @if (requestInProgress) {
                <p-progressSpinner class="uploading-spinner" strokeWidth="6"></p-progressSpinner>
              }
            </button>
          }
        </div>
      </div>
    }
  </div>
} @else {
  <div class="loading">
    <div>
      <p-progressSpinner></p-progressSpinner>
    </div>
    <div>Loading...</div>
  </div>
}
